import moment from "moment";
import React from "react";
import { Card,Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import TagDisplay from "../../common/tags";
import "./styles.css";

function truncate(str, n) {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
}

function RemedyCard({ dispatch, remedy, onPin }) {
  return (
    <Card border="info" className="remedy-card" style={{ minWidth: "18rem" }}>
      <Card.Body>
        <Card.Title
          className="text-center h5 font-weight-normal"
          as={Link}
          to={"/remedy/" + remedy._id}
        >
          {truncate(remedy.title, 90)}
        </Card.Title>
        <TagDisplay tags={remedy.tags} />
      </Card.Body>
        <Button
          style={{ cursor: "pointer" }}
          className={`btn ml-2 mb-2 mr-2 border border-warning`}
          variant={ remedy.pinned === -1 ? "white" : "warning"}
          onClick={() => onPin(remedy._id, remedy.pinned === -1)}
        >
          { remedy.pinned === -1 ? "Bookmark" : "Bookmarked"}
        </Button>
      <Card.Footer className="text-muted">
        Updated {moment(remedy.updated).fromNow(true)} ago
      </Card.Footer>
    </Card>
  );
}

export default RemedyCard;
